import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import { Box, CircularProgress, Dialog } from "@mui/material";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { updateTicketBuyFromApi } from "api/tickets";

function TicketModal({ openModal, closeModal, refreshData, openModalItemData }) {
  const [isOnline, setIsOnline] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (openModalItemData) {
      setIsOnline(openModalItemData?.buyFrom?.online === true);
    }
  }, [openModalItemData]);

  const handleSave = async () => {
    try {
      setIsLoading(true);
      await updateTicketBuyFromApi(openModalItemData._id, {
        online: isOnline,
        offline: !isOnline,
      });
      Swal.fire({ title: "Modifié", text: "", icon: "success" });
      refreshData();
      closeModal();
    } catch (err) {
      console.log(err);
      Swal.fire({ title: "Erreur", text: err?.response?.data?.error || "Erreur inconnue.", icon: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={openModal} onClose={closeModal} fullWidth maxWidth="sm">
      <MDBox>
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={12}>
            <Card sx={{ height: "100%" }}>
              <MDBox p={3}>
                <MDTypography variant="h6" mb={2}>
                  Modifier le ticket
                </MDTypography>
                <MDBox mb={1}>
                  <MDTypography variant="caption" color="text">
                    Référence: {openModalItemData?.ticketID}
                  </MDTypography>
                </MDBox>
                <MDBox mb={1}>
                  <MDTypography variant="caption" color="text">
                    Événement: {openModalItemData?.eventID?.eventTitle}
                  </MDTypography>
                </MDBox>
                <MDBox mt={2}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isOnline}
                        onChange={(e) => setIsOnline(e.target.checked)}
                      />
                    }
                    label={isOnline ? "Online" : "Hors ligne"}
                  />
                </MDBox>
                <MDBox mt={3}>
                  {isLoading ? (
                    <Box sx={{ display: "flex" }}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <MDButton variant="gradient" color="dark" onClick={handleSave}>
                      Enregistrer
                    </MDButton>
                  )}
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </Dialog>
  );
}

TicketModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  refreshData: PropTypes.func.isRequired,
  openModalItemData: PropTypes.object,
};

export default TicketModal;
